// React imports.
import React from "react";

//app imports
import {Assessment3bDataReceivedStatusEnum} from "../state";

const Assessment3bMainTableRow = ({ state, fuel, step, fieldChangeHandler, rowClass }) => (
    <React.Fragment>
        {step.showBothAndNumAndPctAndStatus !== true
        &&
        <React.Fragment>
            <div className={"dwGridRow col1 "+ rowClass} >{fuel.description}
            </div>
            <div className={"dwGridRow  col2 blue-background "+ rowClass}>
                <input id="totalAssistedhHNum" name="totalAssistedhHNum" value={fuel.totalAssistedhHNum} 
                  onChange={(changeEvent) => fieldChangeHandler(changeEvent, fuel)} 
                  className="form-control " />
            </div>
            {step.showMainHeatAndElectric === true &&
                <div className={"dwGridRow  col3 blue-background "+ rowClass} >
                    <input id="hHElecticAndMainHeatDataNum" name="hHElecticAndMainHeatDataNum" value={fuel.hHElecticAndMainHeatDataNum} 
                      onChange={(changeEvent) => fieldChangeHandler(changeEvent, fuel)} 
                      className="form-control " />
                </div>
            }
            {step.showMainHeat === true &&
                <div className={"dwGridRow  col4 yellow-background "+ rowClass} >
                    <input id="hHMainHeatDataNum" name="hHMainHeatDataNum" value={fuel.hHMainHeatDataNum} 
                      onChange={(changeEvent) => fieldChangeHandler(changeEvent, fuel)} 
                      className="form-control " />
                </div>
            }
            {step.showElectricBaseload === true &&
                <div className={"dwGridRow  col5 yellow-background "+ rowClass} >
                    <input id="hHElecticDataNum" name="hHElecticDataNum" value={fuel.hHElecticDataNum} 
                      onChange={(changeEvent) => fieldChangeHandler(changeEvent, fuel)} 
                      className="form-control " />
                </div>
            }
        </React.Fragment>}

        {step.showBothAndNumAndPctAndStatus === true &&
        <React.Fragment>
            <div className={"grid-item dwGridRow colboundary1_2 item"+ rowClass}>{fuel.description}</div>
            <div className={"grid-item dwGridRow  blue-background colboundary2_3 rowboundary1_3 "+ rowClass}>
                <input id="totalAssistedhHNum" name="totalAssistedhHNum" value={fuel.totalAssistedhHNum} 
                  onChange={(changeEvent) => fieldChangeHandler(changeEvent, fuel)} 
                  className="form-control " />
            </div>
            <div className={"grid-item dwGridRow  blue-background colboundary3_4 rowboundary2_3 "+ rowClass}>
                <input id="hHElecticAndMainHeatDataNum" name="hHElecticAndMainHeatDataNum" value={fuel.hHElecticAndMainHeatDataNum} 
                  onChange={(changeEvent) => fieldChangeHandler(changeEvent, fuel)} 
                  className="form-control " />
            </div>
            <div className={"grid-item dwGridRow  colboundary4_5 rowboundary2_3  "+ rowClass+ fuel.hhDataReceivedStatusClassname3b}>
                {fuel.hHBothDataReceivedPercentString}
            </div>

            <div className={"grid-item dwGridRow  yellow-background colboundary5_6 rowboundary2_3 "+ rowClass}>
                <input id="hHMainHeatDataNum" name="hHMainHeatDataNum" value={fuel.hHMainHeatDataNum} 
                      onChange={(changeEvent) => fieldChangeHandler(changeEvent, fuel)} 
                      className="form-control " />
            </div>
            <div className={"grid-item dwGridRow  colboundary6_7 rowboundary2_3  "+ rowClass+ fuel.hhDataReceivedStatusClassname3b}>{fuel.hHMainHeatDataReceivedPercentString}</div>
            <div className={"grid-item dwGridRow yellow-background colboundary7_8 rowboundary2_3 "+ rowClass}>
                <input id="hHElecticDataNum" name="hHElecticDataNum" value={fuel.hHElecticDataNum} 
                      onChange={(changeEvent) => fieldChangeHandler(changeEvent, fuel)} 
                      className="form-control " />
            </div>
            <div className={"grid-item dwGridRow colboundary8_9 rowboundary2_3  "+ rowClass+ fuel.hhDataReceivedStatusClassname3b}>{fuel.hHElectricDataReceivedPercentString}</div>
            <div className={"grid-item dwGridRow colboundary9_11 rowboundary1_3  "+ rowClass+ fuel.hhDataReceivedStatusClassname3b}  dangerouslySetInnerHTML={{__html: fuel.hhDataReceivedStatusString3b}} />
        </React.Fragment>      
        }
    </React.Fragment>
);

export default Assessment3bMainTableRow;
